import {
  UpdateCurrencyMutationVariables,
  useCurrencyQuery,
  useUpdateCurrencyMutation,
} from "../../generated/graphql";
import { useToast } from "@chakra-ui/react";
import Loading from "../../components/loading/Loading";
import { Navigate, useNavigate } from "react-router-dom";
import Form from "./Form";

interface Props {
  id: string;
}

const Update: React.VFC<Props> = ({ id }) => {
  const [updateMutation] = useUpdateCurrencyMutation();
  const navigation = useNavigate();
  const toast = useToast();

  const { loading, error, data } = useCurrencyQuery({
    variables: {
      where: {
        id,
      },
    },
    fetchPolicy: "network-only",
  });

  if (loading) {
    return <Loading />;
  }
  if (error) {
    return <Navigate to="/currency" replace />;
  }

  const handleUpdate = async (data: UpdateCurrencyMutationVariables) => {
    try {
      await updateMutation({
        variables: {
          ...data,
        },
      });

      return toast({
        status: "success",
        title: "Başarılı",
        description: "Para Birimi güncellendi",
        duration: 1000,
        onCloseComplete: () => {
          return navigation("/currency");
        },
      });
    } catch (error: any) {
      return toast({
        status: "error",
        title: "Hata",
        description: error.message || "Bir hata oluştu",
        duration: 1000,
      });
    }
  };

  return (
    <Form actionType="UPDATE" data={data?.currency} id={id} handleUpdate={handleUpdate} />
  );
};

export default Update;
